import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";

const GateOutwards = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIn, setShowGateIn] = useState(false);
  const [date, setDate] = useState(new Date().toISOString());
  const [vehicleNo, setVehicleNo] = useState("");
  const [dispatchNo, setDispatchNo] = useState("");
  const [gateOutId, setGateOutId] = useState("");
  const [firstGateOutId,setFirstGateOutId] = useState("")
  const [latestGateOutId, setLatestGateOutId] = useState("")
  const [gateOutNotes, setGateOutNotes] = useState("");
  const [gateList, setGateList] = useState([]);
  const [gateIn, setGateIn] = useState("");
  const [gateInName, setGateInName] = useState("");
  const [hist, setHist] = useState(false);

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString(),
  );

  const [driversList, setDriversList] = useState([]);
  const [driverName, setDriverName] = useState("");

  const [histData, setHistData] = useState([]);
  const [showHist, setShowhist] = useState(false);
  const [searchHist, setSearchHist] = useState("");
  const [startDateHist, setStartDateHist] = useState("");
  const [endDateHist, setEndDateHist] = useState("");
  const [searchChild, setSearchChild] = useState("");

  const filtHist = histData?.filter((item) => {
    const searchData = searchHist?.toLowerCase().split(" ").filter(Boolean);
    const sDate = new Date(item.OT_GATE_OUT_DISPATCH_DATE);
    const eDate = new Date(item.OT_GATE_OUT_DISPATCH_DATE);
    const startDate = startDateHist ? new Date(startDateHist) : null;
    const endDate = endDateHist ? new Date(endDateHist) : null;

    const gate = gateList?.find(
      (row) => row?.GATEID === item?.["OT_GATE_NUMBER"],
    );

    const textMatch = searchData.every((term) => {
      const gateMatch = gate?.GATENAME?.toLowerCase()?.includes(term) ?? false;

      const otherMatch = [
        "OT_GATE_OUT_NO",
        "OT_GATE_OUT_DISPATCH_NO",
        "OT_GATE_OUT_VEHICLE_REG_NO",
        "OT_GATE_OUT_DISPATCH_NOTES",
      ].some((key) => {
        const columnValue = String(item[key] || "").toLowerCase();
        return columnValue.includes(term);
      });

      return gateMatch || otherMatch;
    });

    const dateMatch =
      (!startDate || sDate >= startDate) && (!endDate || eDate <= endDate);

    return textMatch && dateMatch;
  });

  const VehicleDepartment = useSelector(
    (state) => state?.VehicleDepartmentReducer,
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const filteredData = vehiclesList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "VEHICLE REG NO",
        "DRIVERNAME",
        "MAKE",
        "MODEL",
        "TRAILER NAME ATTACHED",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1091`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setGateOutId(response?.data[0]?.NEW_GATE_OUT_NO);
        setLatestGateOutId(response?.data[0]?.NEW_GATE_OUT_NO)
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });

    // Driver's List  345;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriversList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1261`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filteredData = response?.data?.filter(
          (item) => item?.ENTRYEXIT === "EXIT",
        );
        setGateList(filteredData);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Gate List details 1261:", error);
      });

    // History data - 1092
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1092`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const sortedData = response?.data?.sort(
          (a, b) => a?.OT_GATE_OUT_NO - b?.OT_GATE_OUT_NO,
        );
        setHistData(sortedData);
        setFirstGateOutId(sortedData[0]?.OT_GATE_OUT_NO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching 1092 details:", error);
      });

    // axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1228`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then((res) => {
    //     const filters = res?.data
    //       ?.filter((item) => item?.SECONDWEIGHT === null)
    //       .map((item) => item?.TRUCKNO);

    //     axios
    //       .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
    //         headers: {
    //           "auth-token": authToken,
    //           "session-token": sessionToken,
    //         },
    //       })
    //       .then((response) => {
    //         if (VehicleDepartment !== "") {
    //           const filterData = response?.data?.filter(
    //             (item) =>
    //               item.VEHICLESTATE === "DISPATCHED" &&
    //               item?.DEPARTMENT === VehicleDepartment,
    //           );
    //           const finalVehicles = filterData.filter(
    //             (item) => !filters.has(item?.["VEHICLE REG NO"]),
    //           );
    //           setVehiclesList(finalVehicles);
    //         } else {
    //           const filterData = response?.data?.filter(
    //             (item) => item.VEHICLESTATE === "DISPATCHED",
    //           );
    //           const finalVehicles = filterData.filter(
    //             (item) => !filters.has(item?.["VEHICLE REG NO"]),
    //           );
    //           setVehiclesList(finalVehicles);
    //         }
    //         setisloading(false);
    //       })
    //       .catch((error) => {
    //         setisloading(false);
    //         console.error("Error fetching Charges details:", error);
    //       });
    //   })
    //   .catch((error) => {
    //     setisloading(false);
    //     console.error("Error fetching Weigh in details:", error);
    //   });

    Promise.all([
      axios.get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1228`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      }),
      axios.get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      }),
    ])
      .then(([res1228, res671]) => {
        const normalize = (val) =>
          String(val || "")
            .trim()
            .toUpperCase();

        // trucks to exclude from 1228
        const excludeTruckSet = new Set(
          res1228?.data
            ?.filter((item) => item?.SECONDWEIGHT === null)
            ?.map((item) => normalize(item?.TRUCKNO)),
        );

        // dispatched vehicles from 671
        let vehicles = res671?.data?.filter(
          (item) => item?.VEHICLESTATE === "DISPATCHED",
        );

        // department filter
        if (VehicleDepartment !== "") {
          vehicles = vehicles.filter(
            (item) => item?.DEPARTMENT === VehicleDepartment,
          );
        }

        // FINAL exclusion using "VEHICLE REG NO"
        const finalVehicles = vehicles.filter(
          (item) => !excludeTruckSet.has(normalize(item?.["VEHICLE REG NO"])),
        );

        if (finalVehicles?.length === 0) {
            setShowGateIn(true)
          }
        setVehiclesList(finalVehicles);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching vehicle data:", error);
      });
  };

  async function getNewGateOut() {
   await axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1091`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setGateOutId(response?.data[0]?.NEW_GATE_OUT_NO);
        setLatestGateOutId(response?.data[0]?.NEW_GATE_OUT_NO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });
}

  // Saving
  async function SaveGateIn() {
    //  await axios
    //   .get(`${BASEURL_GLOBAL}/globalSearchHandlerLimit?viewname=1092&sortBy=OT_GATE_OUT_NO`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then(async(response) => {
    //     const sortedData = response?.data?.sort(
    //       (a, b) => b?.OT_GATE_OUT_NO - a?.OT_GATE_OUT_NO,
    //     );
    //     const isGateOutAvailable = sortedData?.find((item) => item?.OT_GATE_OUT_NO === Number(gateOutId))
    //     if (isGateOutAvailable && sortedData[0]?.OT_GATE_OUT_NO > latestGateOutId) {
    //       await getNewGateOut();
    //     }
    //   })
    //   .catch((error) => {
    //     setisloading(false);
    //     console.error("Error fetching 1092 details:", error);
    //   });

    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1093`,
        {
          OT_GATE_OUT_NO: Number(gateOutId),
          OT_GATE_NUMBER: Number(gateIn),
          OT_GATE_OUT_DISPATCH_NO: Number(dispatchNo),
          OT_GATE_OUT_VEHICLE_REG_NO: vehicleNo ? vehicleNo : "",
          OT_GATE_OUT_DISPATCH_DATE: moment(date).format("YYYY/MM/DD"),
          OT_GATE_OUT_DISPATCH_TIME: currentTime,
          OT_GATE_OUT_DISPATCH_NOTES: gateOutNotes ? gateOutNotes : "",
          OT_GATE_OUT_DISPATCH_PROCESSED_BY: user,
          OT_GATE_OUT_NEW_EXISTING: hist === true ? "EXISTING" : "NEW",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        console.log(`Vehicle Gate Out successfully`);
        await SaveVehicleState(response?.data?.message);
      } else {
        alert(`Error while Gating Out Vehicle`);
        setisloading(false);
        console.error(`Error while Gating Out Vehicle`);
      }
    } catch (error) {
      alert(`Error while Gating Out Vehicle`, error);
      setisloading(false);
      console.error(`Error while Gating Out Vehicle`, error);
    }
  }

  async function SaveVehicleState(docNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1053`,
        {
          OT_VEHICLE_REG_NO: vehicleNo,
          OT_VEHICLE_STATE: "GATE OUT",
          OT_VEHICLE_STATE_DATE: moment(date).format("YYYY/MM/DD"),
          OT_VEHICLE_STATE_TIME: currentTime,
          OT_VEHICLE_PREVIOUS_STATE: "DISPATCHED",
          OT_VEHICLE_STATE_UPDATED_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        console.log(`Vehicle State Updated successfully`);
        await SaveState(docNo);
      } else {
        console.error(`Error while saving Vehicle State`);
        alert(`Error while saving Vehicle State`);
        setisloading(false);
      }
    } catch (error) {
      console.error(`Error while saving Vehicle State `, error);
      alert(`Error while saving Vehicle State `, error);
      setisloading(false);
    }
  }

  async function SaveState(docNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1121`,
        {
          TRANSTYPE: "GATE OUT",
          DOC_NO: Number(docNo),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        alert(`Vehicle Gate Out successfully`);
        setisloading(false);
        console.log(`State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving State`);
        alert(`Error while saving State`);
      }
    } catch (error) {
      alert(`Error while saving State `, error);
      setisloading(false);
      console.error(`Error while saving State `, error);
    }
  }

  function fetchLoadingOrderNo(vehicle) {
    //   For Last Gate In No
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1089`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data?.filter(
          (item) => item.OT_DISPATCH_VEHICLE_REG_NO === vehicle,
        );
        setDispatchNo(filter[filter?.length - 1]?.OT_DISPATCH_NO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Verification Data:", error);
      });
  }

  const handleRowClick = (value, index) => {
    setDriverName(value["DRIVERNAME"]);
    setVehicleNo(value["VEHICLE REG NO"]);
    fetchLoadingOrderNo(value["VEHICLE REG NO"]);
    setGateInName("");
    setGateIn("");
    setShowGateIn(true);
  };

  const ExcelStockData = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Gate Outwards");
    const rows = document.querySelectorAll(".table_1 tbody tr");

    const columnWidths = [10, 10, 15, 15, 15, 25, 50];

    // Set column widths for the worksheet
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers
    const headerRow = worksheet.addRow([
      "GATE OUT NO",
      "DISPATCH NO",
      "VEHICLE",
      "DATE",
      "TIME",
      "GATE OUT NAME",
      "NOTES",
    ]);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Add rows from the table
    rows.forEach((row) => {
      const rowData = [];
      row.querySelectorAll("td").forEach((cell) => {
        rowData.push(cell.textContent);
      });
      worksheet.addRow(rowData);
    });

    // Create a blob from the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Gate_Outwards.xlsx";
      link.click();
    });
  };

  const PdfStockData = () => {
    const doc = new jsPDF();

    doc.text("Gate Outwards - Report", 10, 10);

    const columns = [
      "GATE OUT NO",
      "DISPATCH NO",
      "VEHICLE",
      "DATE",
      "TIME",
      "GATE OUT NAME",
      "NOTES",
    ];
    const data = filtHist.map((stock) => {
      const gate = gateList?.find(
        (row) => row?.GATEID === stock?.["OT_GATE_NUMBER"],
      );
      return [
        stock.OT_GATE_OUT_NO,
        stock.OT_GATE_OUT_DISPATCH_NO,
        stock.OT_GATE_OUT_VEHICLE_REG_NO,
        stock.OT_GATE_OUT_DISPATCH_DATE
          ? moment(stock.OT_GATE_OUT_DISPATCH_DATE).format("DD/MM/YYYY")
          : "",
        stock.OT_GATE_OUT_DISPATCH_TIME
          ? moment(stock.OT_GATE_OUT_DISPATCH_TIME).format("hh:MM:ss")
          : "",
        gate?.GATENAME,
        stock.OT_GATE_OUT_DISPATCH_NOTES,
      ];
    });

    doc.autoTable({
      head: [columns],
      body: data,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save("Gate_Outwards.pdf");
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Gate Outwards
        </h1>
        {/* <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        /> */}
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAKE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MODEL
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TRAILER ATTACHED ?
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ATTACHED NAME TRAILER
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 cursor-pointer text-[13px]"
                onClick={() => handleRowClick(value, index)}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["VEHICLE REG NO"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["DRIVERNAME"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MAKE || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MODEL || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER ATTACHED"] === true
                    ? "YES"
                    : value["TRAILER ATTACHED"] === false
                      ? "NO"
                      : "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER NAME ATTACHED"] || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* PopUp */}
      {showGateIn && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[400px] h-[80%] lg:w-[1000px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="text-3xl font-bold flex lg:justify-center justify-start">
            GATE OUT
          </h1>

          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Gate Out Id:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={gateOutId}
              readOnly
            ></input>

            <button
              className="border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-1 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                setShowhist(true);
              }}
            >
              ...
            </button>

            {showHist && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[300px] h-[80%] lg:w-[900px] w-[95%] p-1 overflow-y-auto">
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Search:</p>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={searchHist}
                    onChange={(e) => {
                      setSearchHist(e.target.value);
                    }}
                  ></input>
                  <p className="text-red-600 lg:ml-2">Start Date:</p>
                  <input
                    className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={startDateHist?.split("T")[0]}
                    onChange={(e) => {
                      setStartDateHist(e.target.value);
                    }}
                  ></input>
                  <p className="text-red-600 lg:ml-2">End Date:</p>
                  <input
                    className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={endDateHist?.split("T")[0]}
                    onChange={(e) => {
                      setEndDateHist(e.target.value);
                    }}
                  ></input>
                </div>
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => setShowhist(false)}
                >
                  Close
                </button>
                <div className="visible lg:h-[250px] p-1 z-0 lg:overflow-auto mt-2">
                  <div className="flex justify-end gap-2">
                    <div className="cursor-pointer">
                      <RiFileExcel2Line onClick={ExcelStockData} size={25} />
                    </div>
                    <div className="cursor-pointer">
                      <BsFileEarmarkPdf onClick={PdfStockData} size={25} />
                    </div>
                  </div>

                  <table className="w-full border border-gray-300 text-sm table_1">
                    <thead className="sticky top-0">
                      <tr className="bg-[#2b3f5c] text-white text-[12px] table-header">
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Gate Out No
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Dispatch No
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Vehicle
                        </td>
                        {/* <td className="py-2 px-4 text-left border border-gray-300">
                                      Driver
                                    </td> */}
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Date
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Time
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Gate Out Name
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Notes
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {filtHist?.map((item, index) => {
                        const gate = gateList?.find(
                          (row) => row?.GATEID === item?.["OT_GATE_NUMBER"],
                        );
                        return (
                          <tr
                            className="hover:bg-gray-100 cursor-pointer text-[13px]"
                            onClick={() => {
                              setGateOutId(item?.["OT_GATE_OUT_NO"]);
                              setDispatchNo(item?.["OT_GATE_OUT_DISPATCH_NO"]);
                              setVehicleNo(
                                item?.["OT_GATE_OUT_VEHICLE_REG_NO"],
                              );
                              setDate(item?.["OT_GATE_OUT_DISPATCH_DATE"]);
                              setCurrentTime(
                                item?.["OT_GATE_OUT_DISPATCH_TIME"],
                              );
                              setGateOutNotes(
                                item?.["OT_GATE_OUT_DISPATCH_NOTES"],
                              );
                              setGateIn(item?.["OT_GATE_NUMBER"]);
                              const gate = gateList?.find(
                                (row) =>
                                  row?.GATEID === item?.["OT_GATE_NUMBER"],
                              );
                              setGateInName(gate?.GATENAME);
                              setHist(true)
                              setShowhist(false);
                            }}
                            key={index}
                          >
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {item?.["OT_GATE_OUT_NO"]
                                ? item?.["OT_GATE_OUT_NO"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {item?.["OT_GATE_OUT_DISPATCH_NO"]
                                ? item?.["OT_GATE_OUT_DISPATCH_NO"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["OT_GATE_OUT_VEHICLE_REG_NO"]
                                ? item?.["OT_GATE_OUT_VEHICLE_REG_NO"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["OT_GATE_OUT_DISPATCH_DATE"]
                                ? moment(
                                    item?.["OT_GATE_OUT_DISPATCH_DATE"],
                                  ).format("DD/MM/YYYY")
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["OT_GATE_OUT_DISPATCH_TIME"]
                                ? moment(
                                    item?.["OT_GATE_OUT_DISPATCH_TIME"],
                                  ).format("hh:MM:ss")
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {gate?.GATENAME ? gate?.GATENAME : "NA"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300">
                              {item?.["OT_GATE_OUT_DISPATCH_NOTES"]
                                ? item?.["OT_GATE_OUT_DISPATCH_NOTES"]
                                : "NA"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <p className="text-red-600 lg:ml-2">Dispatch No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={dispatchNo}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-2 mr-1">Vehicle :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNo}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-2">Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={date?.split("T")[0]}
              readOnly
            ></input>
          </div>

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Time :</p>
            <input
              className="w-28 h-8 border border-black lg:ml-12 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={currentTime}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-2">Driver :</p>
            <Select
              className="lg:w-72 w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                driverName
                  ? { value: driverName, label: driverName }
                  : { value: "", label: "Select Driver" }
              }
              onChange={(e) => {
                setDriverName(e.label);
                // setDriverCode(e.value);
              }}
              options={[
                { value: "", label: "Select Driver" },
                ...driversList?.map((item) => ({
                  value: item.DRIVERNAME,
                  label: item.DRIVERNAME,
                })),
              ]}
            ></Select>
          </div>
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Gate :</p>
            <Select
              className="lg:w-48 lg:ml-12"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                gateInName
                  ? { value: gateInName, label: gateInName }
                  : { value: "", label: "Select Gate In" }
              }
              onChange={(e) => {
                setGateInName(e.label);
                setGateIn(e.value);
              }}
              options={[
                { value: "", label: "Select Gate In" },
                ...gateList?.map((item) => ({
                  value: item.GATEID,
                  label: item.GATENAME,
                })),
              ]}
            ></Select>
            <p className="text-red-600 lg:ml-2">Gate Out Notes :</p>
            <textarea
              rows={2}
              className="lg:w-72 resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={gateOutNotes}
              onChange={(e) => setGateOutNotes(e.target.value)}
            ></textarea>
          </div>

          <div className="flex justify-center mt-5">
            <button
              className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                if (!gateInName) {
                  alert("Kindly Supply Gate");
                  return;
                } else if (!gateOutNotes) {
                  alert("Kindly Supply Gate Out Notes");
                  return;
                } else {
                  await SaveGateIn();
                  setShowGateIn(false);
                  window.location.reload();
                }
              }}
            >
              GATE OUT
            </button>
          </div>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateIn(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default GateOutwards;
